<!-- Affected API Flow Section -->
<!-- <div *ngIf="isSeatAvailabilityOverviewPage || isPaymentsPage || isRibbonTile || isRibbonTileSawToothVertical || isAPIFlow"> -->
<div *ngIf="isRibbonTile || isRibbonTileSawToothVertical || isPaymentsPage">
  <div *ngFor="let section of ribbonTileSections">
    <h4 *ngIf="section.heading">
      {{ section.heading }}
    </h4>
    <div class="api-block mb-2 one-Line-api-block" *ngFor="let singleArrowItem of section.bodyArrows; let j = index">
      <div class="tb" *ngFor="let arrowText of singleArrowItem.split(';'); let i = index">
        <div>
          <div *ngIf="isPaymentsPage && i === 0" [ngClass]="{ 'saw-tooth-vertical': j === 1 }"></div>
          <!-- <div *ngIf="isSeatAvailabilityOverviewPage && i === 0" [ngClass]="section.sectionClass !== 'vertical-tooth' ? '' : { 'saw-tooth-vertical': j === 0 || j === 1 }"></div> 
          <div *ngIf="isRibbonTile && i === 0"></div>-->
          <div *ngIf="isRibbonTileSawToothVertical && i === 0" class="saw-tooth-vertical"></div>
          <!-- <div *ngIf="isAPIFlow && i === 0"></div> -->
          <a *ngIf="arrowText.includes(':')" [href]="arrowText.split(':')[1] || '/api/docs'">
            <div
              class="arrow"
              [ngClass]="{
                'bg-color-1': i === 0,
                'bg-color-2': i === 1,
                'bg-color-3': i === 2,
                'bg-color-4': i === 3,
                'bg-color-5': i === 4,
                'bg-color-6': i === 5,
                'bg-color-7': i === 6,
                'bg-color-8': i === 7,
                'bg-color-9': i === 8,
                'bg-color-10': i === 9
              }"
            >
              <div class="coltxt">
                {{ arrowText.split(':')[0] || '' }}
              </div>
            </div>
          </a>
          <div
            *ngIf="!arrowText.includes(':')"
            class="arrow"
            [ngClass]="{
              'bg-color-1': i === 0,
              'bg-color-2': i === 1,
              'bg-color-3': i === 2,
              'bg-color-4': i === 3,
              'bg-color-5': i === 4,
              'bg-color-6': i === 5,
              'bg-color-7': i === 6,
              'bg-color-8': i === 7,
              'bg-color-9': i === 8,
              'bg-color-10': i === 9
            }"
          >
            <div class="coltxt">
              {{ arrowText.split(':')[0] || '' }}
            </div>
          </div>
          <div class="arrow">
            <div
              class="triangle-right"
              [ngClass]="{
                'square-color-1': i === 0,
                'square-color-2': i === 1,
                'square-color-3': i === 2,
                'square-color-4': i === 3,
                'square-color-5': i === 4,
                'square-color-6': i === 5,
                'square-color-7': i === 6,
                'square-color-8': i === 7,
                'square-color-9': i === 8,
                'square-color-10': i === 9
              }"
              [ngStyle]="{ 'background-color': i === singleArrowItem.split(';').length - 1 ? 'white' : '' }"
            ></div>
          </div>
          <!-- <div class="saw-tooth-vertical"></div>    -->
        </div>
      </div>
    </div>
    <div class="clear-float">
      <br />
      <div *ngIf="section.subBody" [innerHTML]="section.subBody || '' | mdToHtml"></div>
    </div>
  </div>
</div>
